import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TokenService {
    getToken (): string | null {
        return sessionStorage.getItem('access_token');
    }

    setToken (token: string): void {
        sessionStorage.setItem('access_token', token);
    }

    clearToken (): void {
        sessionStorage.removeItem('access_token');
    }
}
